import React from 'react';
import './HowToSchedule.css';

const HowToSchedule = () => {
  const steps = [
    {
      number: 1,
      title: "Ingresa a nuestra plataforma digital",
      description: "Accede a nuestra plataforma digital de multiasistencias desde cualquier dispositivo",
      icon: "🌐"
    },
    {
      number: 2,
      title: "Ingresa con tu DNI",
      description: "Ingresa con tu DNI al sistema de multiasistencia para identificarte",
      icon: "🆔"
    },
    {
      number: 3,
      title: "Selecciona tu asistencia",
      description: "Selecciona la asistencia que tienes contratada de tu plan personal",
      icon: "✅"
    },
    {
      number: 4,
      title: "Completa y disfruta",
      description: "Selecciona un servicio, llena los datos y disfruta de tu servicio",
      icon: "🎯"
    }
  ];

  return (
    <section id="como-agendar" className="how-to-schedule">
      <div className="container">
        <div className="schedule-header">
          <h2 className="section-title">¿Cómo agendar digitalmente?</h2>
          <p className="section-subtitle">
            Sigue estos sencillos pasos para solicitar tu asistencia de forma rápida y segura
          </p>
        </div>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card fade-in-up" style={{animationDelay: `${index * 0.2}s`}}>
              <div className="step-number">
                <span>{step.number}</span>
              </div>
              <div className="step-icon">
                <span>{step.icon}</span>
              </div>
              <div className="step-content">
                <h3 className="step-title">Paso {step.number}</h3>
                <h4 className="step-subtitle">{step.title}</h4>
                <p className="step-description">{step.description}</p>
              </div>
              <div className="step-connector">
                {index < steps.length - 1 && (
                  <div className="connector-line">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToSchedule;